const ActivityPage = () => (
  <div className="space-y-4" data-testid="activity-page">
    <h2 className="text-2xl font-semibold" data-testid="activity-title">
      Your activity
    </h2>
    <p className="text-sm text-muted-foreground" data-testid="activity-placeholder">
      Activity history will appear here soon.
    </p>
  </div>
);

export default ActivityPage;
